import React from "react";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import { Link } from "./../util/router";
import "./HeroSection.scss";

function HeroSection(props) {
  return (
    <Section
      color={props.color}
      size={props.size}
      backgroundImage={props.backgroundImage}
      backgroundImageOpacity={props.backgroundImageOpacity}
      className="main-section"
    >
      <div className="container">
        <div className="columns is-vcentered is-desktop">
          <div className="column is-4-desktop has-text-centered-touch">
            <SectionHeader
              title={props.title}
              subtitle={props.subtitle}
              size={1}
              spaced={true}
            />
            <div className="buttons is-inline-flex">
              <Link
                to={props.buttonPath}
                className={
                  "button is-medium" +
                  (props.buttonColor ? ` is-${props.buttonColor}` : "") +
                  (props.buttonInverted ? " is-inverted" : "")
                }
              >
                {props.buttonText}
              </Link>
            </div>
          </div>
          <div className="column has-text-centered column-responsive">
            <img
              src={props.image}
              alt="IllustrationHS"
            />
          </div>
        </div>
      </div>
    </Section>
  );
}

export default HeroSection;
